import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon';

export default createSvgIcon(
  <svg viewBox='0 0 36 37' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_53511_206739)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.5 22.625H4.5V19.625H13.5V22.625ZM4.5 13.625H18V16.625H4.5V13.625ZM18 1.625L25.5 9.125H18V1.625ZM27 15.125V7.004L20.121 0.125H3C1.3455 0.125 0 1.472 0 3.125V30.125C0 31.7795 1.3455 33.125 3 33.125H16.6185C15.594 31.3595 15 29.3135 15 27.125C15 20.498 20.3715 15.125 27 15.125Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M27 30.125C25.341 30.125 24 28.781 24 27.125C24 25.469 25.341 24.125 27 24.125C28.656 24.125 30 25.469 30 27.125C30 28.781 28.656 30.125 27 30.125ZM36.003 28.625V25.625H34.35C34.1535 24.668 33.7725 23.7815 33.2505 22.994L34.4265 21.818L32.3055 19.697L31.128 20.873C30.3435 20.354 29.457 19.97 28.5015 19.778V18.125H25.5015V19.778C24.5445 19.97 23.6595 20.354 22.872 20.8745L21.6975 19.7L19.5765 21.821L20.751 22.997C20.229 23.7815 19.8465 24.6695 19.653 25.625H18V28.625H19.653C19.8465 29.582 20.229 30.4685 20.751 31.256L19.5765 32.432L21.699 34.5515L22.872 33.3755C23.6595 33.8975 24.546 34.28 25.503 34.4735V36.1265H28.503V34.472C29.4585 34.2785 30.3465 33.896 31.1325 33.374L32.3085 34.5485L34.428 32.4275L33.252 31.253C33.774 30.467 34.1535 29.5805 34.35 28.625H36.003Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_53511_206739'>
        <rect
          width='36'
          height='36'
          fill='white'
          transform='translate(0 0.125)'
        />
      </clipPath>
    </defs>
  </svg>,
  'FileSettings'
);
